import React, {PureComponent} from "react"

import {Tooltip, OverlayPlacement} from "@irati/ui/src/Tooltip"
import {Body} from "@irati/ui/src/Typography"
import {FormattedMessage} from "@irati/utils/lang"

import {StyledLabel} from "./styled"

export interface TooltipLabel {
  enabled?: string
  disabled?: string
}

interface Props {
  enabled: boolean
  purchased?: boolean
  tooltip?: TooltipLabel
  text?: string
}

class EnabledDisabledLabel extends PureComponent<Props> {
  render() {
    const {enabled, purchased, tooltip} = this.props
    const bodyText = enabled ? tooltip?.enabled : tooltip?.disabled
    return (
      <>
        {tooltip && (
          <Tooltip
            placement={OverlayPlacement.Top}
            tooltipChildren={
              <Body small padding={[1, 1]}>
                <FormattedMessage id={bodyText} />
              </Body>
            }>
            <StyledLabel enabled={enabled} tooltip={tooltip} weight="semibold">
              {purchased && enabled && <FormattedMessage id="admin.containers.integrations.enabledDisabledLabel.activated" />}
              {purchased && !enabled && <FormattedMessage id="admin.containers.integrations.enabledDisabledLabel.inactive" />}
              {!purchased && <FormattedMessage id="admin.containers.integrations.enabledDisabledLabel.notPurchased" />}
            </StyledLabel>
          </Tooltip>
        )}
        {!tooltip && (
          <StyledLabel enabled={enabled} tooltip={tooltip} weight="semibold">
            {purchased && enabled && <FormattedMessage id="admin.containers.integrations.enabledDisabledLabel.activated" />}
            {purchased && !enabled && <FormattedMessage id="admin.containers.integrations.enabledDisabledLabel.inactive" />}
            {!purchased && <FormattedMessage id="admin.containers.integrations.enabledDisabledLabel.notPurchased" />}
          </StyledLabel>
        )}
      </>
    )
  }
}

export default EnabledDisabledLabel
